import { Container } from 'react-bootstrap';
import Body from '../components/Body';
import HobbyDetailContainer from '../components/hobbies/HobbyDetailContainer';

export default function HobbyDetail() {
  return (
    <Body sidebar>
      <Container fluid className="py-4">
        <HobbyDetailContainer />
      </Container>
    </Body>
  );
}
